<div class="modal-header">
  <div class="title">
    <h2 class="modal-title-prefix"><span translate={{naslov}}></span></h2>
  </div>
</div>
<div class="modal-body">
  <form [formGroup]="baseFormGroup" class="">
      
      <div class="row" *ngIf = "label1Visibility">
          <div class="col-md-12">
            <yt-text-area [MaxLength]="500" 
              name="txtNapomena1" 
              formControlName="Napomena1"
              [Height]="1"
              [Label]="nazivLabele1"
              [ngClass]="{'is-invalid': submitted && fc.Napomena1.invalid}">
            </yt-text-area>      
            <div class="form-error" *ngIf="submitted && fc.Napomena1.invalid">
              <span *ngFor="let validation of errorMessages.Napomena1">
                  <span class="error-message" *ngIf="fc.Napomena1.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
          </div>
          </div>
      </div>
      <div class="row" *ngIf = "label2Visibility">
        <div class="col-md-12">
          <yt-input [MaxLength]="100" 
            [Type]="'text'"
            name="txtNapomena2" 
            formControlName="Napomena2"
            [Label]="nazivLabele2"
            >
          </yt-input>           
        </div>
      </div>
  </form>
</div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-primary" id="btnOk" (click)="Ok()"><span translate="FW.ACTION.OK"></span></button>
    <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span translate="FW.ACTION.CLOSE.ACTION"></span></button>
  </div>